import React from "react";
import {
  BlueBirdTheme, Button, Typography,
} from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import { useTransactionCode } from "../../hooks/Provider";

const { danger, gray } = BlueBirdTheme.colors;

const TransactionCodeFormModal = () => {
  const {
    handleDelete,
    modalConfig,
    setModalConfig,
  } = useTransactionCode();
  return (
    <Modal
      isOpen={modalConfig?.type === "DELETE"}
      setOpen={() => setModalConfig(undefined)}
      title="Konfirmasi hapus data"
      body={<Typography level={5} color={gray.subtitle} fontWeight="medium">
        Apakah Anda yakin ingin menghapus data?
      </Typography>}
      footer={
        <div className="action-container">
          <Button
            variant="text"
            type="button"
            onClick={() => setModalConfig(undefined)}
          >
            Batal
          </Button>
          <Button
            backgroundColor={(modalConfig?.type === "DELETE") ? danger[500] : undefined}
            onClick={handleDelete}
            disabled={!(modalConfig?.type === "DELETE")}
          >
            Ya, hapus
          </Button>
        </div>
      }
    />
  );
};

export default TransactionCodeFormModal;
